import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import WrapperContainer from '../../../components/Container/WrapperContainer';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CleanableInput from '../../../components/Input/CleanableInput';
import CustomTypography from '../../../components/Typography/CustomTypography';
import styles from '../../../assets/jss/pages/adminSettingMultiLanguageStyle';
import Button from '../../../components/Button/CustomButton';
import Validation from '../../../common/Validation';
import SnackBar from '../../../components/Snackbar/Snackbar';

const useStyles = makeStyles(styles);

const SettingMultiLanguage = ({
    fetchEventZones,
    listZones,
    clearEventZone,
    listJobsExhibitor,
    listJobsViewer,
    listOccupationViewer,
    listOccupationOrganizer,
    listCategoryOrganizer,
    getSettingLanguage,
    clearGetSettingLanguage,
    updateSettingLanguage,
    clearUpdateSettingLanguage,
    isLoading,
    settingLanguage,
    updateSuccess,
    errorsUpdate,
    errorsSettingLanguage,
}) => {
    const intl = useIntl();
    const { shortName } = useParams();
    const classes = useStyles();
    const [params, setParams] = useState({
        eventName: '',
        note: '',
        address: '',
        description: '',
        event_organizer_name: '',
        event_organizer_tel: '',
        event_organizer_email: '',
        organizationRequestUrl: '',
    });
    const [validateResults, setValidateResults] = useState({});
    const [listZoneEN, setListZoneEN] = useState({});
    const [listOccupationOrganizerEN, setListOccupationOrganizerEN] = useState({});
    const [listOccupationViewerEN, setListOccupationViewerEN] = useState({});
    const [listCategoryOrganizerEN, setListCategoryOrganizerEN] = useState({});
    const [listJobsExhibitorEN, setListJobsExhibitorEN] = useState({});
    const [listJobsViewerEN, setListJobsViewerEN] = useState({});
    const [openSnackBar, setOpenSnackBar] = useState({ isOpen: false, message: '', type: '' });

    useEffect(() => {
        fetchEventZones(shortName);
        getSettingLanguage({ event_name: shortName });
        return () => {
            clearEventZone();
            clearGetSettingLanguage();
            clearUpdateSettingLanguage();
        };
    }, []);

    useEffect(() => {
        if (!_.isEmpty(settingLanguage)) {
            setParams({
                eventName: settingLanguage.name_en,
                note: settingLanguage.note_en,
                address: settingLanguage.address_en,
                description: settingLanguage.description_en,
                event_organizer_name: settingLanguage.event_organizer_name_en,
                event_organizer_tel: settingLanguage.event_organizer_tel_en,
                event_organizer_email: settingLanguage.event_organizer_email_en,
                organizationRequestUrl: settingLanguage.organization_request_url_en,
            });
        }
    }, [settingLanguage]);

    useEffect(() => {
        if (!_.isEmpty(listZones)) {
            let objZone = {};
            // eslint-disable-next-line array-callback-return
            listZones.map((value, index) => {
                objZone = { ...objZone, [`zone_${index}`]: value.name_en };
            });
            setListZoneEN(objZone);
        }
    }, [listZones]);

    
    useEffect(() => {
        if (!_.isEmpty(listCategoryOrganizer)) {
            let categoryOrganizer = {};
            // eslint-disable-next-line array-callback-return
            listCategoryOrganizer.map((value, index) => {
                categoryOrganizer = {
                    ...categoryOrganizer,
                    [`category_organizer_${index}`]:
                    (settingLanguage.category_organizer_en && settingLanguage.category_organizer_en[index]
                        && settingLanguage.category_organizer_en[index].trim()) || '',
                };
            });
            setListCategoryOrganizerEN(categoryOrganizer);
        }
    }, [listCategoryOrganizer, settingLanguage]);

    useEffect(() => {
        if (!_.isEmpty(listOccupationOrganizer)) {
            let occupationOrganizer = {};
            // eslint-disable-next-line array-callback-return
            listOccupationOrganizer.map((value, index) => {
                occupationOrganizer = {
                    ...occupationOrganizer,
                    [`occupation_organizer_${index}`]:
                    (settingLanguage.occupations_organizer_en && settingLanguage.occupations_organizer_en[index]
                        && settingLanguage.occupations_organizer_en[index].trim()) || '',
                };
            });
            setListOccupationOrganizerEN(occupationOrganizer);
        }
    }, [listOccupationOrganizer, settingLanguage]);

    useEffect(() => {
        if (!_.isEmpty(listOccupationViewer)) {
            let occupationViewer = {};
            // eslint-disable-next-line array-callback-return
            listOccupationViewer.map((value, index) => {
                occupationViewer = {
                    ...occupationViewer,
                    [`occupation_viewer_${index}`]:
                    (settingLanguage.occupations_viewer_en && settingLanguage.occupations_viewer_en[index]
                        && settingLanguage.occupations_viewer_en[index].trim()) || '',
                };
            });
            setListOccupationViewerEN(occupationViewer);
        }
    }, [listOccupationViewer, settingLanguage]);

    useEffect(() => {
        if (!_.isEmpty(listJobsExhibitor)) {
            let jobExhibition = {};
            // eslint-disable-next-line array-callback-return
            listJobsExhibitor.map((value, index) => {
                jobExhibition = {
                    ...jobExhibition,
                    [`jobs_exhibition_${index}`]: (settingLanguage.jobs_en && settingLanguage.jobs_en[index] && settingLanguage.jobs_en[index].trim()) || '',
                };
            });
            setListJobsExhibitorEN(jobExhibition);
        }
    }, [listJobsExhibitor, settingLanguage]);

    useEffect(() => {
        if (!_.isEmpty(listJobsViewer)) {
            let jobViewer = {};
            // eslint-disable-next-line array-callback-return
            listJobsViewer.map((value, index) => {
                jobViewer = {
                    ...jobViewer,
                    [`jobs_viewer_${index}`]: (settingLanguage.jobs_viewer_en && settingLanguage.jobs_viewer_en[index] && settingLanguage.jobs_viewer_en[index].trim()) || '',
                };
            });
            setListJobsViewerEN(jobViewer);
        }
    }, [listJobsViewer, settingLanguage]);

    useEffect(() => {
        if (updateSuccess) {
            setOpenSnackBar({ isOpen: true, message: '更新しました。', type: 'success' });
            clearUpdateSettingLanguage();
            fetchEventZones(shortName);
            getSettingLanguage({ event_name: shortName });
        }
    }, [updateSuccess]);

    useEffect(() => {
        if (!_.isEmpty(errorsUpdate)) {
            setOpenSnackBar({ isOpen: true, message: errorsUpdate?.message?.message || '', type: 'error' });
            clearUpdateSettingLanguage();
        }
    }, [errorsUpdate]);

    const handleSetParams = (field, value) => {
        setParams((prevParams) => ({ ...prevParams, [field]: value }));
    };

    const handleSetZone = (field, value) => {
        setListZoneEN((prevParams) => ({ ...prevParams, [field]: value }));
    };

    const handleChangeValue = (field, value, fieldChange) => {
        if (fieldChange === 'occupation_viewer') {
            setListOccupationViewerEN((prevParams) => ({ ...prevParams, [field]: value }));
        } else if (fieldChange === 'jobs_exhibition') {
            setListJobsExhibitorEN((prevParams) => ({ ...prevParams, [field]: value }));
        } else if (fieldChange === 'jobs_viewer') {
            setListJobsViewerEN((prevParams) => ({ ...prevParams, [field]: value }));
        } else if (fieldChange === 'occupation_organizer') {
            setListOccupationOrganizerEN((prevParams) => ({ ...prevParams, [field]: value }));
        } else if (fieldChange === 'category_organizer') {
            setListCategoryOrganizerEN((prevParams) => ({ ...prevParams, [field]: value }));
       }
    };

    const getValueDefault = (field, fieldChange) => {
        let text = '';
        if (fieldChange === 'occupation_viewer') {
            text = listOccupationViewerEN[`${field}`];
        } else if (fieldChange === 'jobs_exhibition') {
            text = listJobsExhibitorEN[`${field}`];
        } else if (fieldChange === 'jobs_viewer') {
            text = listJobsViewerEN[`${field}`];
        } else if (fieldChange === 'occupation_organizer') {
            text = listOccupationOrganizerEN[`${field}`];
        } else if (fieldChange === 'category_organizer') {
            text = listCategoryOrganizerEN[`${field}`];
        }
        return text;
    };

    const validate = () => {
        const validateRules = {};
        validateRules.eventName = [
            () => Validation.isNotEmpty(params.eventName),
            () => Validation.validateLatin(params.eventName),
            () => Validation.validateMaxLength(params.eventName, 100),
        ];
        validateRules.note = [
            () => Validation.validateMaxLength(params.note, 255),
            () => params.note && Validation.validateLatin(params.note),
        ];
        validateRules.address = [
            () => Validation.isNotEmpty(params.address),
            () => Validation.validateLatin(params.address),
        ];
        validateRules.description = [
            () => Validation.isNotEmpty(params.description),
            () => Validation.validateLatin(params.description),
            () => Validation.validateMaxLength(params.description, 1000),
        ];
        validateRules.event_organizer_name = [
            () => params.event_organizer_name && Validation.validateLatin(params.event_organizer_name),
            () => Validation.validateMaxLength(params.event_organizer_name, 255),
        ];
        validateRules.event_organizer_tel = [
            () => Validation.validatePhoneNumber(params.event_organizer_tel.trim()),
        ];
        validateRules.event_organizer_email = [
            () => Validation.validateEmail(params.event_organizer_email.trim()),
        ];
        validateRules.organizationRequestUrl = [
            () => Validation.isNotEmpty(params.organizationRequestUrl),
            () => Validation.validateMaxLength(params.organizationRequestUrl, 255),
            () => Validation.isValidUrl(params.organizationRequestUrl),
        ];
        Object.entries(listZoneEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateUniqueZoneEN(Object.values(listZoneEN), item[1]),
                () => Validation.validateLimitLengthZone(item[1]),
            ];
        });
        Object.entries(listCategoryOrganizerEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateMaxLength(item[1], 255),
            ];
        });
        Object.entries(listOccupationOrganizerEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateMaxLength(item[1], 255),
            ];
        });
        Object.entries(listOccupationViewerEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateMaxLength(item[1], 255),
            ];
        });
        Object.entries(listJobsExhibitorEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateMaxLength(item[1], 255),
            ];
        });
        Object.entries(listJobsViewerEN).forEach((item) => {
            validateRules[item[0]] = [
                () => Validation.validateLatin(item[1]),
                () => Validation.isNotEmpty(item[1]),
                () => Validation.validateMaxLength(item[1], 255),
            ];
        });
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const renderZone = () => (
        <>
            <GridContainer className={classes.item}>
                <GridItem xs={12} sm={3} md={2}>
                    <CustomTypography bold>
                        ゾーン
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            {
                listZones.map((item, index) => (
                    <GridContainer key={+index} className={classes.item}>
                        <GridItem xs={12} sm={3} md={2} className={classes.itemAlignRight}>
                            <CustomTypography required bold>
                                {item.name}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={10}>
                            <CleanableInput
                                defaultValue={listZoneEN[`zone_${index}`]}
                                onChange={(value) => handleSetZone(`zone_${index}`, value)}
                                error={!!validateResults[`zone_${index}`]}
                                helperText={validateResults[`zone_${index}`]
                                    ? intl.formatMessage({ id: validateResults[`zone_${index}`].message }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                ))
            }
        </>
    );

    const renderJobAndOccupation = (title, listJobAndOccupation, field) => (
        <>
            <GridContainer className={classes.item}>
                <GridItem xs={12} sm={3} md={2}>
                    <CustomTypography bold>
                        {title}
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            {
                listJobAndOccupation.map((item, index) => (
                    <GridContainer key={+index} className={classes.item}>
                        <GridItem xs={12} sm={3} md={2} className={classes.itemAlignRight}>
                            <CustomTypography required bold>
                                {item}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={10}>
                            <CleanableInput
                                defaultValue={getValueDefault(`${field}_${index}`, field)}
                                onChange={(value) => handleChangeValue(`${field}_${index}`, value, field)}
                                error={!!validateResults[`${field}_${index}`]}
                                helperText={validateResults[`${field}_${index}`]
                                    ? intl.formatMessage({ id: validateResults[`${field}_${index}`].message }, { maxLength: 255 }) : ''}
                            />
                        </GridItem>
                    </GridContainer>
                ))
            }
        </>
    );

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const handleSubmit = () => {
        if (validate()) {
            const zone = [];
            // eslint-disable-next-line array-callback-return
            listZones.map((value, index) => {
                zone.push({ ...value, zone_name_en: listZoneEN[`zone_${index}`] });
            });
            const sbData = {
                event_name: shortName,
                data: {
                    name_en: checkUndefined(params.eventName),
                    note_en: checkUndefined(params.note),
                    description_en: checkUndefined(params.description),
                    address_en: checkUndefined(params.address),
                    jobs_en: _.join(Object.values(listJobsExhibitorEN), ','),
                    jobs_viewer_en: _.join(Object.values(listJobsViewerEN), ','),
                    occupations_viewer_en: _.join(Object.values(listOccupationViewerEN), ','),
                    occupations_organizer_en: _.join(Object.values(listOccupationOrganizerEN), ','),
                    category_organizer_en: _.join(Object.values(listCategoryOrganizerEN), ','),
                    event_organizer_name_en: checkUndefined(params.event_organizer_name),
                    event_organizer_tel_en: checkUndefined(params.event_organizer_tel),
                    event_organizer_email_en: checkUndefined(params.event_organizer_email),
                    organization_request_url_en: checkUndefined(params.organizationRequestUrl),
                    zones_en: zone,
                },
            };
            updateSettingLanguage(sbData);
        }
    };

    const handleCloseSnackBar = (e, reason) => {
        if (reason === 'clickaway') return;
        setOpenSnackBar({ ...openSnackBar, isOpen: false });
    };

    return (
        <GridContainer style={{ marginTop: '20px' }}>
            <WrapperContainer>
                <GridItem>
                    <Paper elevation={3} classes={{ root: classes.room }}>
                        <GridContainer>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography required bold>
                                    催し名
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.eventName}
                                    onChange={(value) => handleSetParams('eventName', value)}
                                    error={!!validateResults.eventName}
                                    helperText={validateResults.eventName
                                        ? intl.formatMessage({ id: validateResults.eventName.message }, { maxLength: 100 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold>
                                    備考
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.note}
                                    onChange={(value) => handleSetParams('note', value)}
                                    error={!!validateResults.note}
                                    helperText={validateResults.note
                                        ? intl.formatMessage({ id: validateResults.note.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold required>
                                    開催場所
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.address}
                                    onChange={(value) => handleSetParams('address', value)}
                                    error={!!validateResults.address}
                                    helperText={validateResults.address
                                        ? intl.formatMessage({ id: validateResults.address.message }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold required>
                                    概要
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.description}
                                    onChange={(value) => handleSetParams('description', value)}
                                    error={!!validateResults.description}
                                    helperText={validateResults.description
                                        ? intl.formatMessage({ id: validateResults.description.message }, { maxLength: 1000 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        {!_.isEmpty(listZones) && renderZone()}

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold>
                                    事務局名
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.event_organizer_name}
                                    onChange={(value) => handleSetParams('event_organizer_name', value)}
                                    error={!!validateResults.event_organizer_name}
                                    helperText={validateResults.event_organizer_name
                                        ? intl.formatMessage({ id: validateResults.event_organizer_name.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold>
                                    事務局TEL
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.event_organizer_tel}
                                    onChange={(value) => handleSetParams('event_organizer_tel', value)}
                                    error={!!validateResults.event_organizer_tel}
                                    helperText={validateResults.event_organizer_tel
                                        ? intl.formatMessage(
                                            { id: validateResults.event_organizer_tel.message },
                                        ) : ''}
                                />
                                <CustomTypography className={classes.right}>
                                    記入例：045-912-2112 → 0459122112 と入力
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold>
                                    事務局Email
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.event_organizer_email}
                                    onChange={(value) => handleSetParams('event_organizer_email', value)}
                                    error={!!validateResults.event_organizer_email}
                                    helperText={validateResults.event_organizer_email
                                        ? intl.formatMessage({ id: validateResults.event_organizer_email.message }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.item}>
                            <GridItem xs={12} sm={3} md={2}>
                                <CustomTypography bold required>
                                    出展募集要項
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={10}>
                                <CleanableInput
                                    defaultValue={params.organizationRequestUrl}
                                    onChange={(value) => handleSetParams('organizationRequestUrl', value)}
                                    error={!!validateResults.organizationRequestUrl}
                                    helperText={validateResults.organizationRequestUrl
                                        ? intl.formatMessage({ id: validateResults.organizationRequestUrl.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        {!_.isEmpty(listJobsExhibitor) && renderJobAndOccupation('出展者の業種', listJobsExhibitor, 'jobs_exhibition')}
                        {!_.isEmpty(listJobsViewer) && renderJobAndOccupation('入場者の業種', listJobsViewer, 'jobs_viewer')}
                        {!_.isEmpty(listOccupationOrganizer) && renderJobAndOccupation('出展者の職種', listOccupationOrganizer, 'occupation_organizer')}
                        {!_.isEmpty(listOccupationViewer) && renderJobAndOccupation('入場者の職種', listOccupationViewer, 'occupation_viewer')}
                        {!_.isEmpty(listCategoryOrganizer) && renderJobAndOccupation('出展エリア', listCategoryOrganizer, 'category_organizer')}
                    </Paper>
                </GridItem>
                <GridItem className={classes.buttonSubmit}>
                    <Button
                        color="info"
                        round
                        gradient
                        size="md"
                        onClick={handleSubmit}
                        style={{ width: '200px', fontSize: '20px' }}
                    >
                        <b>保存する</b>
                    </Button>
                </GridItem>
            </WrapperContainer>
            <SnackBar
                open={openSnackBar.isOpen}
                onClose={handleCloseSnackBar}
                message={openSnackBar.message}
                severity={openSnackBar.type}
                autoHideDuration={3000}
            />
        </GridContainer>
    );
};

SettingMultiLanguage.defaultProps = {
    fetchEventZones: () => {},
    listZones: [],
    clearEventZone: () => {},
    listJobsExhibitor: [],
    listJobsViewer: [],
    listOccupationViewer: [],
    listOccupationOrganizer: [],
    ListCategoryOrganizer: [],
    getSettingLanguage: () => {},
    clearGetSettingLanguage: () => {},
    updateSettingLanguage: () => {},
    clearUpdateSettingLanguage: () => {},
    isLoading: false,
    settingLanguage: {},
    updateSuccess: false,
    errorsUpdate: {},
    errorsSettingLanguage: {},
};

SettingMultiLanguage.propTypes = {
    fetchEventZones: PropTypes.func,
    listZones: PropTypes.oneOfType([() => null, PropTypes.array]),
    clearEventZone: PropTypes.func,
    listJobsExhibitor: PropTypes.oneOfType([() => null, PropTypes.array]),
    listJobsViewer: PropTypes.oneOfType([() => null, PropTypes.array]),
    listOccupationViewer: PropTypes.oneOfType([() => null, PropTypes.array]),
    listOccupationOrganizer: PropTypes.oneOfType([() => null, PropTypes.array]),
    listCategoryOrganizer: PropTypes.oneOfType([() => null, PropTypes.array]),
    getSettingLanguage: PropTypes.func,
    clearGetSettingLanguage: PropTypes.func,
    updateSettingLanguage: PropTypes.func,
    clearUpdateSettingLanguage: PropTypes.func,
    isLoading: PropTypes.bool,
    settingLanguage: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateSuccess: PropTypes.bool,
    errorsUpdate: PropTypes.oneOfType([() => null, PropTypes.object]),
    errorsSettingLanguage: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default SettingMultiLanguage;
